"use client"; 

import { usePathname } from "next/navigation"; 
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/Footer";
import classes from "./layout.module.scss";

export default function DashboardLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const pathname = usePathname(); 
  const isHomePage = pathname === '/' ? true : false;

  return (
    <>
      <Header className={isHomePage ? classes["homepage-header-class"] : ""} />
      {children}
      <Footer />
    </>
  );
}
